import { TActions } from '../../types';
import { IAuctionState } from './types';
import { LOAD_PUBLISH_TERMS_SUCCESS } from '../publishTerms';
import { defaultState } from './defaultState';
import { CLEAR_AUCTION_BET, CLOSE_AUCTION, INPUT_AUCTION_BET, OPEN_AUCTION, REVERT_AUCTION_BET } from './actions';

export function auction(state: IAuctionState = defaultState, action: TActions): IAuctionState {
  switch (action.type) {
    case LOAD_PUBLISH_TERMS_SUCCESS: {
      const { auction } = action.payload;
      const currentBet = state.currentBet || auction.currentBet;

      return {
        ...state,
        ...auction,
        currentBet,
      };
    }

    case OPEN_AUCTION:
      return {
        ...state,
        isOpen: true,
        prevBet: state.currentBet,
      };

    case CLOSE_AUCTION:
      return {
        ...state,
        isOpen: false,
      };

    case INPUT_AUCTION_BET:
      return {
        ...state,
        currentBet: action.payload,
      };

    case REVERT_AUCTION_BET:
      return {
        ...state,
        currentBet: state.prevBet,
      };

    case CLEAR_AUCTION_BET:
      return {
        ...state,
        currentBet: 0,
      };

    default:
      return state;
  }
}
